import { useEffect, useRef, useState } from "react"
import { Tooltip } from "react-tooltip"
import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { UITypes } from "types"

const NotesText = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  word-break: break-word;
`

const StyledTooltip = styled(Tooltip)`
  max-width: 300px;
  padding: 8px 12px !important;
  border-radius: 6px !important;
`

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const CustomerNotes = ({ cell: { getValue, row } }: Props) => {
  const notes = getValue().value ? String(getValue().value) : ""
  const textRef = useRef<HTMLSpanElement>(null)
  const element = useRef(null)
  const [isTruncated, setIsTruncated] = useState(false)
  const rowId = row.original.rowSettings?.id || Math.random().toString(36).substr(2, 9)
  const tooltipId = `notes-${rowId}`

  useEffect(() => {
    if (textRef.current) {
      const element = textRef.current
      setIsTruncated(element.scrollHeight > element.clientHeight)
    }
  }, [notes])

  if (!notes) {
    return <span>-</span>
  }

  return (
    <>
      {isTruncated && (
        <StyledTooltip id={tooltipId} ref={element}>
          {notes}
        </StyledTooltip>
      )}
      <NotesText ref={textRef} data-tooltip-id={isTruncated ? tooltipId : undefined}>
        {notes}
      </NotesText>
    </>
  )
}
